import { render, staticRenderFns } from "./DataReloader.vue?vue&type=template&id=1d13cf0d&scoped=true&"
import script from "./DataReloader.vue?vue&type=script&lang=js&"
export * from "./DataReloader.vue?vue&type=script&lang=js&"
import style0 from "./DataReloader.vue?vue&type=style&index=0&id=1d13cf0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13cf0d",
  null
  
)

export default component.exports